export default {"src":"/_next/static/media/orchestration_ru.f795744d.svg","height":1440,"width":2004};